<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>{{ isEdit ? '编辑积分商品' : '新增积分商品' }}</span>
        <div class="header-actions">
          <el-button @click="backToList">返回列表</el-button>
          <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
        </div>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="60" show-word-limit />
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model.trim="form.subTitle" maxlength="120" show-word-limit />
        </el-form-item>
        <el-form-item label="主图" prop="mainImage">
          <div class="upload-row">
            <el-input v-model.trim="form.mainImage" placeholder="请输入图片地址或直接上传" />
            <input ref="fileInput" type="file" accept="image/*" class="upload-input" @change="handleUpload" />
            <el-button :loading="uploading" @click="$refs.fileInput.click()">上传图片</el-button>
          </div>
          <el-image v-if="form.mainImage" class="preview-image" :src="form.mainImage" fit="cover" />
        </el-form-item>
        <el-form-item label="详情说明">
          <el-input v-model.trim="form.detailContent" type="textarea" :rows="8" placeholder="可填写图文说明、兑换说明、发货提醒等" />
        </el-form-item>
        <el-form-item label="兑换积分" prop="pointsCost">
          <el-input-number v-model="form.pointsCost" :min="1" :step="1" />
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input-number v-model="form.stock" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  addPointProduct,
  getPointProductDetail,
  updatePointProduct,
  uploadAdminImage
} from '../../api/admin'

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploading: false,
      submitting: false,
      form: {
        id: null,
        name: '',
        subTitle: '',
        mainImage: '',
        detailContent: '',
        pointsCost: 1,
        stock: 0,
        sort: 0,
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        mainImage: [{ required: true, message: '请上传或填写主图', trigger: 'blur' }],
        pointsCost: [{ required: true, message: '请输入兑换积分', trigger: 'change' }],
        stock: [{ required: true, message: '请输入库存', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'change' }]
      }
    }
  },
  computed: {
    isEdit() {
      return Boolean(this.id)
    }
  },
  created() {
    if (this.isEdit) {
      this.loadDetail()
    }
  },
  methods: {
    async loadDetail() {
      try {
        const data = await getPointProductDetail(this.id)
        this.form = {
          ...this.form,
          ...data
        }
      } catch (error) {
        this.$message.error(error?.message || '积分商品详情加载失败')
      }
    },
    async handleUpload(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) {
        return
      }
      this.uploading = true
      try {
        const data = await uploadAdminImage(file)
        this.form.mainImage = data.url
        this.$message.success('图片上传成功')
      } catch (error) {
        this.$message.error(error?.message || '图片上传失败')
      } finally {
        this.uploading = false
        event.target.value = ''
      }
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        try {
          const payload = { ...this.form }
          if (this.isEdit) {
            await updatePointProduct(payload)
          } else {
            await addPointProduct(payload)
          }
          this.$message.success(this.isEdit ? '保存成功' : '新增成功')
          this.backToList()
        } catch (error) {
          this.$message.error(error?.message || (this.isEdit ? '积分商品保存失败' : '积分商品新增失败'))
        } finally {
          this.submitting = false
        }
      })
    },
    backToList() {
      this.$router.push({
        path: '/point-mall/products',
        query: this.$route.query.q ? { q: this.$route.query.q } : {}
      })
    }
  }
}
</script>

<style scoped>
.card-header { display: flex; justify-content: space-between; align-items: center; }
.header-actions { display: flex; gap: 12px; }
.upload-row { display: flex; gap: 12px; align-items: center; }
.upload-input { display: none; }
.preview-image { width: 120px; height: 120px; margin-top: 12px; border-radius: 12px; }
</style>
